if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.submitButton = this.querySelector('.sticky-buy-bar__submit');
        this.priceWrapper = this.querySelector(`#StickyPrice-${this.sectionId}`);

        const watchTarget = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

        if (watchTarget && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            const [entry] = entries;
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggleAttribute('data-visible', scrolledPast);
          });
          this.observer.observe(watchTarget);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId || !event.data.variant) return;
            this.updateForVariant(event.data.variant, event.data.html);
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      }

      updateForVariant(variant, sourceHtml) {
        if (this.priceWrapper && sourceHtml) {
          const sourcePrice = sourceHtml.querySelector(`#price-${this.sectionId}`);
          if (sourcePrice) this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }

        if (this.submitButton) {
          this.submitButton.disabled = !variant.available;
          this.submitButton.textContent = variant.available
            ? this.submitButton.dataset.addToCartText
            : this.submitButton.dataset.soldOutText;
        }
      }
    }
  );
}
